import cloudFunctionApi from '../../../../cloudfunctions';
import firebaseApi from '../../../../firebase/firebaseApi';
import { useAbortController } from '../../../../hooks/useAbortController';
import {
	useUserAuthContext,
	useUserDetailsContext,
} from '../../../../providers/UserProvider';
import { LoadingDots } from '../../../Management/subcomponents/LoadingDots';
import { Export } from './Export';

export const ExportWrapper = (): JSX.Element => {
	const userDetails = useUserDetailsContext();
	const abordSignal = useAbortController();
	const user = useUserAuthContext();

	return userDetails === null || user === null ? (
		<LoadingDots />
	) : (
		<Export
			userDetails={userDetails}
			user={user}
			abortSignal={abordSignal}
			exportTitle="CATProjects Export"
			firebaseApi={firebaseApi}
			cloudFunctionApi={cloudFunctionApi}
		/>
	);
};
